import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';

import { ProjectDataActions, selectActiveInsights } from '@rapider/project-data';
import { DataInsightComponent } from '../data-insight/data-insight.component';
import { DataInsightTimelineComponent } from '../data-insight-timeline/data-insight-timeline.component';

/**
 * @class WorkspaceCanvasComponent
 * @description The root router component for the main application canvas.
 * It listens to the NgRx store to determine if the user has requested to view a specific Data Insight from the chat.
 */
@Component({
  selector: 'rapider-workspace-canvas',
  standalone: true,
  imports: [CommonModule, DataInsightComponent, DataInsightTimelineComponent],
  templateUrl: './workspace-canvas.component.html',
  host: { class: 'block w-full h-full' }
})
export class WorkspaceCanvasComponent {
  private readonly store = inject(Store);

  // Reactively track the aggregated queue of active insights from the store
  public activeInsights = this.store.selectSignal(selectActiveInsights);

  // Clears the active insights to return back to the Timeline View
  public clearInsight(): void {
    this.store.dispatch(ProjectDataActions.setActiveInsight({ insight: null }));
  }
}